import './index.styl';
import template from './index.jst';

import { Model } from 'backbone';
import Radio from 'backbone.radio';
import { View } from 'backbone.marionette';

import { isMobile } from '../../../utils';

const
	tippingRadio = Radio.channel('tipping'),
	nonDigitRegExp = new RegExp('[^\\d\\.]*', 'g'),
	// betBtnUrlPart = part => {
	// 	return [
	// 		'&leg=leg_sort~%7Cleg_type~W%7Clp_num~%7',
	// 		`Clp_den~%7Chcap_value~%7Cbir_index~%7Cbanker~%7Cselns~${part}`
	// 	].join('');
	// },
	// BET_BTN_BASE_URL =
	// 'http://pubads.g.doubleclick.net/gampad/clk?id=126954663&iu=/7414/TEL.NRL';
	BET_BTN_BASE_URL = isMobile() ?
		`https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329252167;
		dc_trk_aid=521056745;dc_trk_cid=148493239;
		dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=` :
		`https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B27287487.329093600;
		dc_trk_aid=521058914;dc_trk_cid=148493239;dc_lat=;dc_rdid=;
		tag_for_child_directed_treatment=;tfua=;ltd=`;

export class WidgetBets extends View {
	get template() {
		return template;
	}

	get className() {
		return 'widget-bet';
	}

	ui() {
		return {
			stake: '.js-stake',
			odds: '.js-multi-odds',
			estimated_return: '.js-estimated-return'
		}
	}

	events() {
		return {
			'keyup @ui.stake': 'onChangeStake',
			'blur @ui.stake': 'onBlurStake',
		}
	}

	initialize() {
		this.model = new Model({
			stake: 10,
			multi_odds: 0,
			bet_btn_url: BET_BTN_BASE_URL,
			is_mobile: isMobile(),
			round_status: '',
			sports_bet_ios: `
				https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B25296542.295376590;
				dc_trk_aid=489026260;dc_trk_cid=142873052;dc_lat=;dc_rdid=;
				tag_for_child_directed_treatment=;tfua=;gdpr=$%7BGDPR%7D;
				gdpr_consent=$%7BGDPR_CONSENT_755%7D;ltd=
			`,
			sports_bet_android: `
				https://ad.doubleclick.net/ddm/trackclk/N7629.128652.NRL/B25296542.295376590;
				dc_trk_aid=489026260;dc_trk_cid=142873052;dc_lat=;dc_rdid=;
				tag_for_child_directed_treatment=;tfua=;gdpr=$%7BGDPR%7D;
				gdpr_consent=$%7BGDPR_CONSENT_755%7D;ltd=
			`
		});

		this.listenTo(this.model, 'change', this.render);
		this.listenTo(tippingRadio, 'user:tips', this.calculateOdds);
		this.listenTo(tippingRadio, 'tips:round:change', this.isShowCalculate)
	}

	calculateOdds(tips) {
		let bet_btn_url = BET_BTN_BASE_URL;

		const multi_odds = tips.reduce((odds, tip) => {
			const {
					predict_winner_squad_id,
					home_squad_id,
					// home_squad_odds_id,
					// away_squad_odds_id,
					home_squad_odds,
					away_squad_odds
				} = tip,
				is_home_squad_selected = predict_winner_squad_id === home_squad_id,
				selected_team_odds = (
					is_home_squad_selected ? home_squad_odds : away_squad_odds
				);
				// selected_team_odds_id = (
				// 	is_home_squad_selected ? home_squad_odds_id : away_squad_odds_id
				// );

			// bet_btn_url += betBtnUrlPart(selected_team_odds_id);

			if (odds) {
				return odds * selected_team_odds;
			}
			else {
				return selected_team_odds;
			}
		}, 0);

		this.model.set({
			multi_odds: Math.round10(multi_odds, -2),
			bet_btn_url
		});
	}

	stakeValueToNumber(value) {
		const
			max_bet = 999.99,
			digit_only = value.replace(nonDigitRegExp, ''),
			current_bet = parseFloat(digit_only) || 0,
			min_num = Math.min(current_bet, max_bet);

		return Math.round10(min_num, -2);
	}

	onChangeStake({ target }) {
		const stake = this.stakeValueToNumber(target.value);

		this.model.set({ stake }, { silent: true });

		const str = `$${Math.round10(this.model.get('multi_odds') * stake, -2).toFixed(2)}`;

		this.ui.estimated_return.text(str);
	}

	onBlurStake({ target }) {
		const stake = this.stakeValueToNumber(target.value);

		target.value = `$${stake.toFixed(2)}`;
	}

	isShowCalculate( status ) {
		if( status === 'complete' ) {
			$('.widget-bet').hide();
		}
		else {
			$('.widget-bet').show();
		}
	}

}

export default WidgetBets;